/**
 * @fileoverview Utilitário de persistência para todos os dispositivos.
 * Implementa localStorage para garantir persistência em Safari e dispositivos móveis.
 * 
 * @module MobilePersistence
 * @since 1.0.0
 */

import { persistData } from './localStorage.js';

/**
 * Gerenciador de persistência que funciona em todas as plataformas.
 * Sempre usa localStorage para garantir compatibilidade com Safari.
 */
export const mobilePersistence = {
  /**
   * Verifica se deve usar persistência local (sempre true para compatibilidade Safari).
   * @returns {boolean}
   */
  shouldPersist: () => true,

  /**
   * Salva favoritos no localStorage.
   * @param {Array} favorites - Lista de favoritos
   */
  saveFavorites: (favorites) => {
    persistData.saveFavorites(favorites);
  },

  /**
   * Carrega favoritos do localStorage.
   * @returns {Array} Lista de favoritos ou array vazio
   */
  loadFavorites: () => {
    return persistData.loadFavorites();
  },

  /**
   * Salva carrinho no localStorage.
   * @param {Array} cart - Itens do carrinho
   */
  saveCart: (cart) => {
    persistData.saveCart(cart);
  },

  /**
   * Carrega carrinho do localStorage.
   * @returns {Array} Itens do carrinho ou array vazio
   */
  loadCart: () => {
    return persistData.loadCart();
  },

  /**
   * Limpa dados locais.
   */
  clearAll: () => {
    persistData.clearAll();
  },

  /**
   * Verifica se há dados locais salvos.
   * @returns {boolean}
   */
  hasLocalData: () => {
    return persistData.hasLocalData();
  }
};

export default mobilePersistence;